export default __webpack_public_path__ + "static/media/drill-jason.2b870582.jpg";